import React, { useState, useEffect, useRef, useCallback } from "react";
import { canAction } from '../common/permissionhelper';
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import CommonAlert from "../common/Commonalert";
import { http } from "../helper";
import { read, utils } from "xlsx";
import { BaseUrl } from "../common/config";
import NoImage from "../assets/images/no-image.jpg";
import Sidebar from "../common/sidebar";
import DataTable from "react-data-table-component";
import Popup from "../common/popup";
import EditProductDetails from "./editProductDetails";
import Importpopup from "../common/importpopup";
import { PricebandExcelReport } from "./pricebandExcelReport";
import {
  dateformatwithuktime,
  capitalizeFirstLetter,
} from "../utilityfunctions";
import { useTranslation } from "react-i18next";

const Products = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState([]);
  const [priceCode] = useState("PL1");
  const [tempproducts, setTempproducts] = useState([]);
  const [searchTextVal, setSearchTextVal] = useState("");
  const [categoryVal, setCategoryVal] = useState("");
  const [viewImage, setViewImage] = useState("");
  const [popupView, setPopupView] = useState("");
  const [filterByValue, setFilterByValue] = useState("");
  const [isElementVisible, setIsElementVisible] = useState(false);
  const [isElementVisibleMobile, setIsElementVisibleMobile] = useState(false);
  const [filterSelectedValue, setFilterSelectedValue] = useState([]);
  const [filterValueList, setFilterValueList] = useState([]);
  const [activeProducts, setActiveProducts] = useState([]);
  const [isActive, setIsActive] = useState([]);
  const [filterCount, setFilterCount] = useState({});
  const [showDialog, setShowDialog] = useState(false);
  const [showReasonPopup, setShowReasonPopup] = useState(false);
  const [confirmationAction, setConfirmationAction] = useState("");
  const [filterCounts, setFilterCounts] = useState({});
  const [editProdDet, setEditProdDet] = useState(false);
  const [ProductDet, setProductDet] = useState({});
  const [alertMessage, setAlertMessage] = useState("");
  const [alertPopup, setAlertPopup] = useState(false);
  const [showpdfViewer, setShowpdfViewer] = useState(false);
  const [pdfURL, setPdfURL] = useState("");
  const [ShowConfirm, setShowConfirm] = useState(false);
  const [popuplogView, setPopuplogView] = useState("");
  const [reason, setReason] = useState("");
  const [filterapply, setFilterapply] = useState(false);
  const [tempFilterSelectedValue, setTempFilterSelectedValue] = useState([]);
  const [allergenFilterSelectedValue, setAllergenFilterSelectedValue] = useState([]);
  const [groupFilterSelectedValue, setGroupFilterSelectedValue] = useState([]);
  const [taxFilterSelectedValue, setTaxFilterSelectedValue] = useState([]);
  const [tempFilterCounts, setTempFilterCounts] = useState({});
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadMessage, setUploadMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [PrdpriceselectedFile, setPrdpriceselectedFile] = useState(null);
  const [isPrdpriceUploading, setIsPrdpriceUploading] = useState(false);
  const [popupImportView, setPopupImportView] = useState(false);
  const [importValue, setImportValue] = useState("");
  const [selectedStatus, setSelectedStatus] = useState(" ");
  const [moreFilter, setMoreFilter] = useState(false);
  const [taxFilterList, setTaxFilterList] = useState([]);
  const [depotPopupView, setDepotPopupView] = useState('');
  const [fullText, setFullText] = useState(false);
  const [depots, setDepots] = useState([]);
  const [showExportAlert, setShowExportAlert] = useState(false);
  const [priceBands, setPriceBands] = useState([]);
  const [selectedPriceBands, setSelectedPriceBands] = useState([]);
  const [confirmExport, setConfirmExport] = useState(false);
  const [allergens, setAllergens] = useState([]);
  const [ingredientsHigh, setIngredientsHigh] = useState([]);
  const [groupFilterList, setGroupFilterList] = useState([]);
  const [groupProductsList, setGroupProductsList] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [previousFilteredProducts, setPreviousFilteredProducts] = useState([]);
  const [PriceBand, setPriceBand] = useState([]);
  const [pricebandView, setPricebandView] = useState("");
  const [exportType, setExportType] = useState("grouped");
  const [reasonError, setReasonError] = useState(false);
  const [inactiveProducts, setInactiveProducts] = useState([]);
  const dropdownRef = useRef(null);
  const dropdownMobileRef = useRef(null);
  const fileInputRef = useRef(null);
  const fileInputPrdpriceRef = useRef(null);
  
  if (!sessionStorage.getItem("isLoggedIn")) window.location.href = "/";
  if (
    JSON.parse(sessionStorage.getItem("authData")) != "" &&
    !JSON.parse(sessionStorage.getItem("authData")).adminRole.permissions.includes("manage_products")
  ) {
    window.location.href = "/unauthorized";
  }
  // helpers kept as stable refs so they can be referenced in effects
  const handleClickOutside = useCallback((event) => {
    if (dropdownRef && dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsElementVisible(false);
    }
  }, []);

  const handleClickOutsideMobile = useCallback((event) => {
    if (
      dropdownMobileRef &&
      dropdownMobileRef.current &&
      !dropdownMobileRef.current.contains(event.target)
    ) {
      setIsElementVisibleMobile(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("mousedown", handleClickOutsideMobile);
    getProducts(priceCode);
    getAllergenlist();
    getIngredientslist();
    getAllDepots();
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("mousedown", handleClickOutsideMobile);
    };
  }, []);

  const priceFormat = (price) => {
    return price.toLocaleString("en-US", {
      style: "currency",
      currency: "GBP",
      minimumFractionDigits: 2,
    });
  };

  const allergenMapping = {
    [t("no_celery_txt")]: ["CELERY"],
    [t("no_cereals_containing_gluten_txt")]: ["CEREALS CONTAINING GLUTEN", "CEREALS", "CEREAL", "GLUTEN", "GLUTENS", "WHEAT GLUTEN"],
    [t("no_crustaceans_txt")]: ["CRUSTACEANS", "CRUSTACEAN"],
    [t("no_eggs_txt")]: ["EGGS", "EGG"],
    [t("no_fish_txt")]: ["FISH"],
    [t("no_lupin_txt")]: ["LUPIN"],
    [t("no_milk_txt")]: ["MILK"],
    [t("no_molluscs_txt")]: ["MOLLUSCS"],
    [t("no_mustard_txt")]: ["MUSTARD"],
    [t("no_peanuts_txt")]: ["PEANUTS"],
    [t("no_sesame_txt")]: ["SESAME", "SESAME SEEDS"],
    [t("no_soybeans_txt")]: ["SOYBEANS", "SOY", "SOYA"],
    [t("no_sulphur_dioxide_and_sulphites_txt")]: ["SULPHUR DIOXIDE", "SULPHITES", "SULPHITE"],
    [t("no_tree_nuts_txt")]: ["TREE NUTS", "NUTS"],
    [t("no_cerelas_txt")]: ["CERELAS"],
    [t("no_wheat_txt")]: ["WHEAT"],
    [t("no_barley_txt")]: ["BARLEY"],
    [t("no_oats_txt")]: ["OATS"],
    [t("no_rye_txt")]: ["RYE"],
  };

  const getAllergenlist = () => {
    const URL = BaseUrl + "admin/allergenlist";
    http
      .get(URL)
      .then((response) => {
        const responseData = response.data.data;
        const apiAllergens = responseData.map((item) => item.allergenTitle.toUpperCase());
        const matchedTeamLabels = new Set();
        Object.entries(allergenMapping).forEach(([Label, variants]) => {
          const matchFound = variants.some((variant) =>
            apiAllergens.includes(variant.toUpperCase())
          );
          if (matchFound) matchedTeamLabels.add(Label);
        });
        setAllergens(Array.from(matchedTeamLabels));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getIngredientslist = () => {
    let URL = BaseUrl + "admin/ingredientlist";
    http
      .get(URL)
      .then((response) => {
        let responseData = response.data.data;
        var ingredientsdata = [];
        responseData.map((item) => {
          ingredientsdata.push(item.ingredientTitle);
        });
        setIngredientsHigh(ingredientsdata);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAllDepots = () => {
    let URL = BaseUrl + `admin/getdepots`;
    http
      .get(URL)
      .then((response) => {
        let responseData = response.data.data;
        setDepots(responseData);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleImage = (item) => {
    let viewdddImage = (
      <Popup
        extClass="prt-poup prod-img-pop show"
        closebtn={
          <>
            <span
              onClick={() => setViewImage("")}
              className="close"
            ></span>
          </>
        }
        headMoreTxt={
          <>
            <div className="order-top">
              <h4>
                <span>
                  {item.productDescription} ({item.productNumber})
                </span>
              </h4>
            </div>
          </>
        }
        bodyMoreTxt={
          <>
            <div className="prt-bdy-img">
              <img
                src={
                  item.productImage !== "" && item.productImage !== null
                    ? item.productImage
                    : NoImage
                }
                alt={t("product_txt")}
              />
              <div className="prt-dsc">
                <span className="pop-prt-txt">{item.productName}</span>
              </div>
            </div>
          </>
        }
      />
    );
    setViewImage(viewdddImage);
  };

  const hightLightIngredients = (str) => {
    ingredientsHigh.forEach((substr) => {
      var strRegExp = new RegExp("\\b" + substr + "\\b", "ig");
      str = str.replaceAll(strRegExp, "<strong>" + substr + "</strong>");
    });
    return <div dangerouslySetInnerHTML={{ __html: str }} />;
  };

  const highlightAllergens = (str) => {
    Object.values(allergenMapping)
      .flat()
      .forEach((substr) => {
        const strRegExp = new RegExp("\\b" + substr + "\\b", "ig");
        str = str.replaceAll(strRegExp, "<strong>" + substr + "</strong>");
      });
    return <div dangerouslySetInnerHTML={{ __html: str }} />;
  };

  const editProduct = (ProductDet) => {
    setEditProdDet(true);
    setProductDet(ProductDet);
  };

  const editclosepopup = (alrtpopup, alrtmsg) => {
    setEditProdDet(false);
    setAlertPopup(alrtpopup);
    setAlertMessage(alrtmsg);
  };

  const editPrdDetails = async (formData) => {
    let URL = BaseUrl + "admin/editproductdetail/" + formData.Pid;
    setLoading(true);
    const data = new FormData();
    Object.keys(formData).forEach((key) => {
      if (key === "prodImage" || key === "prodSpec") {
        if (formData[key]) {
          data.append(key, formData[key]);
        }
      } else {
        data.append(key, formData[key]);
      }
    });
    try {
      await http.put(URL, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });
    } catch (err) {
      console.log(err);
      setLoading(false);
    } finally {
      setAlertPopup(true);
      setAlertMessage(t("product_details_updated_success_txt"));
      setLoading(false);
      setEditProdDet(false);
    }
  };

  const handlespecClick = (productSpec) => {
    const pdfName = productSpec.split("/").pop();
    const pdfUrl = `${BaseUrl}getpdf/auth/${pdfName}`;
    sessionStorage.setItem("pdfUrl", pdfUrl);
    sessionStorage.setItem(
      "token",
      sessionStorage.getItem("authData")
        ? JSON.parse(sessionStorage.getItem("authData")).token
        : ""
    );
    const newTabUrl = `${window.location.origin}/PdfViewer`;
    window.open(newTabUrl, "_blank");
  };

  const handleExportClick = async () => {
    try {
      const response = await http.get(`${BaseUrl}/products/exportPriceBandExcelReport`);
      const data = response.data;
      const uniqueBands = [...new Set(data.map(item => item.priceBand))];
      setPriceBands(uniqueBands);
      setSelectedPriceBands(uniqueBands);
      setExportType('grouped');
      setConfirmExport(false);
      setShowExportAlert(true);
    } catch (error) {
      console.error(error);
      setConfirmExport(false);
      setShowExportAlert(true);
    }
  };

  const handleExportToExcel = () => {
    setShowExportAlert(false);
    setConfirmExport(false);
    PricebandExcelReport(selectedPriceBands, exportType);
  };

  const handleCloseExportAlert = () => {
    setShowExportAlert(false);
    setConfirmExport(false);
  };

  const handlePriceBandSelection = (band) => {
    setSelectedPriceBands(prev => {
      const selected = prev.includes(band)
        ? prev.filter(b => b !== band)
        : [...prev, band];
      return selected;
    });
    setConfirmExport(false);
  };

  const handleSelectAllPriceBands = () => {
    setSelectedPriceBands(prev => {
      const allSelected = prev.length === priceBands.length;
      return allSelected ? [] : [...priceBands];
    });
    setConfirmExport(false);
  };

  const handleExportTypeChange = (e) => {
    setExportType(e.target.value);
  };

  const viewProductDetails = (prd_det) => {
    let popupResult = (
      <Popup
        extClass="info-poup show"
        closebtn={
          <>
            <span
              onClick={() => setPopupView("")}
              className="close"
            ></span>
          </>
        }
        headMoreTxt={
          <>
            <div className="order-top">
              <h4>
                <span>
                  {prd_det.productDescription} - {prd_det.productNumber}
                </span>
              </h4>
            </div>
          </>
        }
        bodyMoreTxt={
          <>
            <div className="info-bdy">
              {prd_det.packageSize !== null && prd_det.packageSize !== "" && (
                <div className="info-item">
                  <div className="info-innr">
                    <h5>
                      <span>{t("unit_of_sale_txt")}</span>
                    </h5>
                    <p>{prd_det.packageSize}</p>
                  </div>
                </div>
              )}
              {prd_det.productIngredient !== null &&
                prd_det.productIngredient !== "" && (
                  <div className="info-item">
                    <div className="info-innr">
                      <h5>
                        <span>{t("ingredient_txt")}</span>
                      </h5>
                      <p>
                        {hightLightIngredients(prd_det.productIngredient)}
                      </p>
                    </div>
                  </div>
                )
              }
              {prd_det.productSpec !== null && prd_det.productSpec !== "" && (
                <div className="info-item">
                  <div className="info-innr">
                    <h5>
                      <span>{t("product_specific_txt")}</span>
                    </h5>
                    <p>
                      <a href={prd_det.productSpec} target="_blank">
                        {t("click_here_txt")}{" "}
                      </a>{" "}
                      {t("no_allergen_information_txt")}
                    </p>
                  </div>
                </div>
              )}
              {prd_det.productUSP !== null && prd_det.productUSP !== "" && (
                <div className="info-item">
                  <div className="info-innr">
                    <h5>
                      <span>{t("allergens_txt")}</span>
                    </h5>
                    <p>
                      {prd_det.productUSP.toLowerCase().trim() ===
                        "no allergens"
                        ? t("no_allergen_txt")
                        : highlightAllergens(prd_det.productUSP)}
                    </p>
                  </div>
                </div>
              )}
              {prd_det.productDiet !== null && prd_det.productDiet !== "" && (
                <div className="info-item">
                  <div className="info-innr">
                    <h5>
                      <span>{t("diet_suitablity_txt")}</span>
                    </h5>
                    <p>{prd_det.productDiet}</p>
                  </div>
                </div>
              )}
            </div>
          </>
        }
      />
    );
    setPopupView(popupResult);
  };

  const viewDepotDetails = (prd_det) => {
    console.log(depots, prd_det?.activeDepots, "depots");
    const productDepots = prd_det.activeDepots.split('/');
    const mainandsubDepot = productDepots.map(sub => {
      const match = depots.find(
        d => d.subDepot.toLowerCase() === sub.toLowerCase()
      );
      return {
        subDepot: sub,
        mainDepot: match ? match.mainDepot : null
      };
    });
    const groupeddepot = Object.values(
      mainandsubDepot.reduce((acc, { mainDepot, subDepot }) => {
        if (!acc[mainDepot]) {
          acc[mainDepot] = { mainDepot, subDepot: [] };
        }
        acc[mainDepot].subDepot.push(subDepot);
        return acc;
      }, {})
    );
    let popupResult = (
      <Popup
        extClass="info-poup show"
        closebtn={
          <>
            <span
              onClick={() => setDepotPopupView("")}
              className="close"
            ></span>
          </>
        }
        headMoreTxt={
          <>
            <div className="order-top">
              <h4>
                <span>
                  {prd_det.productDescription} - {prd_det.productNumber}
                </span>
              </h4>
            </div>
          </>
        }
        bodyMoreTxt={
          <>
            <div className="info-bdy">
              <div className="info-item">
                <div className="info-innr">
                  <h5>
                    <span>{t("main_sub_depot_txt")}</span>
                  </h5>
                  {groupeddepot.map((depot) => (
                    <>
                      <div className="depot-content">
                        <p style={{ fontWeight: 'bold' }} key={`${depot.mainDepot}_main`}>{depot.mainDepot}:</p>
                        <p key={`${depot.mainDepot}_sub`}>{depot.subDepot.join(', ')} </p>
                      </div>
                    </>
                  ))}
                </div>
              </div>
            </div>
          </>
        }
      />
    );
    setDepotPopupView(popupResult);
  };

  const viewPricebandDetails = (prd_det) => {
    let URL = BaseUrl + `admin/productband/${prd_det.productNumber}`;
    var PricebandData = [];
    http
      .get(URL)
      .then((response) => {
        let responsePricebandData = response.data.data;
        responsePricebandData.map((item) => {
          PricebandData.push({
            reference: item.PDP_Reference,
            price: item.PDP_Price1,
          });
        });
        setPriceBand(PricebandData);
        viewPricebandPopup(PricebandData, prd_det);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const viewPricebandPopup = (PricebandData, prd_det) => {
    let popupResult = (
      <Popup
        extClass="info-poup show"
        closebtn={
          <>
            <span
              onClick={() => setPricebandView("")}
              className="close"
            ></span>
          </>
        }
        headMoreTxt={
          <>
            <div className="order-top">
              <h4>
                <span>
                  {prd_det.productDescription} - {prd_det.productNumber}
                </span>
              </h4>
            </div>
          </>
        }
        bodyMoreTxt={
          <>
            <div className="info-bdy">
              <div className="info-item">
                <div className="info-innr">
                  <div className="vendor-table-view">
                    {PricebandData.length > 0 ? (
                      <table className="vendor-table dtp-price-table">
                        <thead>
                          <tr>
                            <th>{t("price_band_txt")}</th>
                            <th>{t("price_txt")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {PricebandData.map((item, index) => (
                            <tr key={index}>
                              <td>{item.reference}</td>
                              <td>{priceFormat(Number(item.price))}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <div className="no-data-message">{t("no_priceband_txt")}</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </>
        }
      />
    );
    setPricebandView(popupResult);
  };

  const getProducts = (pCode) => {
    let URL = `${BaseUrl}admin/productprice/${pCode}`;
    setLoading(true);
    http
      .get(URL)
      .then((response) => {
        let responseData = response.data.data;
        let duplicateResponse = response.data.data;
        duplicateResponse.sort(dynamicSort("ProductGroup"));
        var filterList = [];
        duplicateResponse.map((item) => {
          if (item.SuitableFor !== "" && item.SuitableFor !== null) {
            filterList.push(item.SuitableFor);
          }
        });
        var taxcodeFilterList = [...new Set(
          duplicateResponse
            .filter(item => item.productTaxCode)
            .map(item => item.productTaxCode)
        )];
        var duplicateFilterRemove = filterList.filter(
          (item, index) => filterList.indexOf(item) === index
        );
        var productGroupList = [];
        duplicateResponse.map((item) => {
          if (item.ProductGroup !== "" && item.ProductGroup !== null) {
            productGroupList.push(item.ProductGroup);
          }
        });
        var duplicateGroupRemove = productGroupList.filter(
          (item, index) => productGroupList.indexOf(item) === index
        );
        let groupProductsListLocal = [];
        duplicateGroupRemove.map((item) => {
          let productGroup = [];
          duplicateResponse.map((product) => {
            if (item == product.ProductGroup) {
              productGroup.push(product);
            }
          });
          if (productGroup.length > 0) {
            groupProductsListLocal.push({ [item]: productGroup });
          }
        });
        setProducts(duplicateResponse);
        setActiveProducts([]);
        setInactiveProducts([]);
        setFilterValueList(duplicateFilterRemove);
        setTempproducts(duplicateResponse);
        setGroupProductsList(groupProductsListLocal);
        setGroupFilterList(duplicateGroupRemove);
        setTaxFilterList(taxcodeFilterList);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const dynamicSort = (property) => {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      if (sortOrder == -1 && b[property] !== null) {
        return b[property].localeCompare(a[property]);
      } else if (a[property] !== null) {
        return a[property].localeCompare(b[property]);
      }
    };
  };

  const handleReset = () => {
    let productsToSearch = filterapply ? previousFilteredProducts : tempproducts;
    setSearchTextVal("");
    setProducts(productsToSearch);
  };

  const handleChange = async (value) => {
    setSearchTextVal(value);
    setCategoryVal("");
    filterData('search', value);
  };

  const handlefilterChange = async (value) => {
    setSelectedStatus(value);
    // applyFilter is called after state update — we trigger it via a dedicated effect or inline
    // To mirror the original behavior (setState callback), we call applyFilterWith directly
    applyFilterWith({
      tempFilterSelectedValue,
      allergenFilterSelectedValue,
      groupFilterSelectedValue,
      taxFilterSelectedValue,
      selectedStatus: value,
    });
    filterData('status', value);
  };

  const handleReasonChange = (e) => {
    setReason(e.target.value);
    setReasonError(false);
  };

  const filterData = async (filterType, value) => {
    const lowercasedValue = value.toLowerCase().trim();
    let newTempFilter = [...tempFilterSelectedValue];
    let newAllergenFilter = [...allergenFilterSelectedValue];
    let newGroupFilter = [...groupFilterSelectedValue];
    let newTaxFilter = [...taxFilterSelectedValue];
    if (filterType === 'suitablefor') {
      newTempFilter = newTempFilter.includes(lowercasedValue)
        ? newTempFilter.filter(item => item !== lowercasedValue)
        : [...newTempFilter, lowercasedValue];
      setTempFilterSelectedValue(newTempFilter);
    }
    if (filterType === 'allergenfilter') {
      newAllergenFilter = newAllergenFilter.includes(lowercasedValue)
        ? newAllergenFilter.filter(item => item !== lowercasedValue)
        : [...newAllergenFilter, lowercasedValue];
      setAllergenFilterSelectedValue(newAllergenFilter);
    }
    if (filterType === 'groupfilter') {
      newGroupFilter = newGroupFilter.includes(lowercasedValue)
        ? newGroupFilter.filter(item => item !== lowercasedValue)
        : [...newGroupFilter, lowercasedValue];
      setGroupFilterSelectedValue(newGroupFilter);
    }
    if (filterType === 'taxfilter') {
      newTaxFilter = newTaxFilter.includes(lowercasedValue)
        ? newTaxFilter.filter(item => item !== lowercasedValue)
        : [...newTaxFilter, lowercasedValue];
      setTaxFilterSelectedValue(newTaxFilter);
    }
    const isFilterApplied =
      tempFilterSelectedValue.length > 0 ||
      groupFilterSelectedValue.length > 0 ||
      taxFilterSelectedValue.length > 0 ||
      allergenFilterSelectedValue.length > 0 ||
      selectedStatus != ' ';
    let productsToSearch = isFilterApplied ? filteredProducts : tempproducts;
    if (filterType === 'search') {
      const result = productsToSearch.filter(item => {
        return ["productDescription", "productNumber", "productUSP", "productIngredient"].some(key =>
          item[key]?.toString().toLowerCase().includes(lowercasedValue)
        );
      });
      setProducts(result);
    }
  };

  const openFilterOption = () => {
    setMoreFilter(true);
  };

  const closeFilterOption = () => {
    setMoreFilter(false);
    setTempFilterSelectedValue([]);
    setAllergenFilterSelectedValue([]);
    setGroupFilterSelectedValue([]);
    setTaxFilterSelectedValue([]);
  };

  const removeFilterpop = (event, value) => {
    const updatedTempFilter = tempFilterSelectedValue.filter(f => f !== value);
    const updatedGroupFilter = groupFilterSelectedValue.filter(f => f !== value);
    const updatedTaxFilter = taxFilterSelectedValue.filter(f => f !== value);
    const updatedAllergenFilter = allergenFilterSelectedValue.filter(f => f !== value);
    let filtered = tempproducts;
    if (updatedTempFilter.length > 0) {
      filtered = filtered.filter(product =>
        updatedTempFilter.includes(product.SuitableFor.toLowerCase())
      );
    }
    if (updatedAllergenFilter.length > 0) {
      const expandedAllergens = updatedAllergenFilter.flatMap(f => f.toLowerCase().split(/\s+/));
      filtered = filtered.filter(product => {
        const usp = (product.productUSP || "").toLowerCase();
        const uspWords = usp.replace(/[^a-z\s]/g, ' ').split(/\s+/);
        const containsAllergen = expandedAllergens.some(allergen =>
          uspWords.some(word => {
            const cleanWord = word.replace(/[^a-z]/g, '');
            return cleanWord === allergen || cleanWord.replace(/s$/, '') === allergen.replace(/s$/, '');
          })
        );
        return usp.includes("no allergens") || !containsAllergen || usp.trim() === "";
      });
    }
    if (updatedGroupFilter.length > 0) {
      filtered = filtered.filter(product =>
        updatedGroupFilter.includes(product.ProductGroup.toLowerCase())
      );
    }
    if (updatedTaxFilter.length > 0) {
      filtered = filtered.filter(product =>
        updatedTaxFilter.includes(product.productTaxCode.toLowerCase())
      );
    }
    if (selectedStatus !== ' ') {
      filtered = filtered.filter(product =>
        product.PDP_Status.toLowerCase() === selectedStatus.toLowerCase().trim()
      );
    }
    const updatedFilterCounts = {};
    updatedTempFilter.forEach((filter) => {
      updatedFilterCounts[filter] = filtered.filter(
        (item) => item.SuitableFor && item.SuitableFor.toLowerCase().trim() === filter.toLowerCase().trim()
      ).length;
    });
    updatedAllergenFilter.forEach(filter => {
      const expanded = filter.toLowerCase().split(/\s+/);
      updatedFilterCounts[filter] = filtered.filter(product => {
        const usp = (product.productUSP || "").toLowerCase();
        const uspWords = usp.replace(/[^a-z\s]/g, ' ').split(/\s+/);
        const containsAllergen = expanded.some(allergen =>
          uspWords.some(word => {
            const cleanWord = word.replace(/[^a-z]/g, '');
            return cleanWord === allergen || cleanWord.replace(/s$/, '') === allergen.replace(/s$/, '');
          })
        );
        return usp.includes("no allergens") || !containsAllergen || usp.trim() === "";
      }).length;
    });
    updatedGroupFilter.forEach((filter) => {
      updatedFilterCounts[filter] = filtered.filter(
        (item) => item.ProductGroup && item.ProductGroup.toLowerCase().trim() === filter.toLowerCase().trim()
      ).length;
    });
    updatedTaxFilter.forEach((filter) => {
      updatedFilterCounts[filter] = filtered.filter(
        (item) => item.productTaxCode && item.productTaxCode.toLowerCase().trim() === filter.toLowerCase().trim()
      ).length;
    });
    setTempFilterSelectedValue(updatedTempFilter);
    setGroupFilterSelectedValue(updatedGroupFilter);
    setTaxFilterSelectedValue(updatedTaxFilter);
    setAllergenFilterSelectedValue(updatedAllergenFilter);
    setFilterSelectedValue([...updatedTempFilter, ...updatedGroupFilter, ...updatedTaxFilter, ...updatedAllergenFilter]);
    setFilteredProducts(filtered);
    setFilterCounts(updatedFilterCounts);
  };

  const removeFilter = (event, value) => {
    const updatedTempFilter = tempFilterSelectedValue.filter(f => f !== value);
    const updatedGroupFilter = groupFilterSelectedValue.filter(f => f !== value);
    const updatedTaxFilter = taxFilterSelectedValue.filter(f => f !== value);
    const updatedAllergenFilter = allergenFilterSelectedValue.filter(f => f !== value);
    let filtered = tempproducts;
    if (updatedTempFilter.length > 0) {
      filtered = filtered.filter(product =>
        updatedTempFilter.includes(product.SuitableFor.toLowerCase())
      );
    }
    if (updatedAllergenFilter.length > 0) {
      const expandedAllergens = updatedAllergenFilter.flatMap(f => f.toLowerCase().split(/\s+/));
      filtered = filtered.filter(product => {
        const usp = (product.productUSP || "").toLowerCase();
        const uspWords = usp.replace(/[^a-z\s]/g, ' ').split(/\s+/);
        const containsAllergen = expandedAllergens.some(allergen =>
          uspWords.some(word => {
            const cleanWord = word.replace(/[^a-z]/g, '');
            return cleanWord === allergen || cleanWord.replace(/s$/, '') === allergen.replace(/s$/, '');
          })
        );
        return usp.includes("no allergens") || !containsAllergen || usp.trim() === "";
      });
    }
    if (updatedGroupFilter.length > 0) {
      filtered = filtered.filter(product =>
        updatedGroupFilter.includes(product.ProductGroup.toLowerCase())
      );
    }
    if (updatedTaxFilter.length > 0) {
      filtered = filtered.filter(product =>
        updatedTaxFilter.includes(product.productTaxCode.toLowerCase())
      );
    }
    if (selectedStatus !== ' ') {
      filtered = filtered.filter(product =>
        product.PDP_Status.toLowerCase() === selectedStatus.toLowerCase().trim()
      );
    }
    const updatedFilterCounts = {};
    updatedTempFilter.forEach((filter) => {
      updatedFilterCounts[filter] = filtered.filter(
        (item) => item.SuitableFor && item.SuitableFor.toLowerCase().trim() === filter.toLowerCase().trim()
      ).length;
    });
    updatedAllergenFilter.forEach(filter => {
      const expanded = filter.toLowerCase().split(/\s+/);
      updatedFilterCounts[filter] = filtered.filter(product => {
        const usp = (product.productUSP || "").toLowerCase();
        const uspWords = usp.replace(/[^a-z\s]/g, ' ').split(/\s+/);
        const containsAllergen = expanded.some(allergen =>
          uspWords.some(word => {
            const cleanWord = word.replace(/[^a-z]/g, '');
            return cleanWord === allergen || cleanWord.replace(/s$/, '') === allergen.replace(/s$/, '');
          })
        );
        return usp.includes("no allergens") || !containsAllergen || usp.trim() === "";
      }).length;
    });
    updatedGroupFilter.forEach((filter) => {
      updatedFilterCounts[filter] = filtered.filter(
        (item) => item.ProductGroup && item.ProductGroup.toLowerCase().trim() === filter.toLowerCase().trim()
      ).length;
    });
    updatedTaxFilter.forEach((filter) => {
      updatedFilterCounts[filter] = filtered.filter(
        (item) => item.productTaxCode && item.productTaxCode.toLowerCase().trim() === filter.toLowerCase().trim()
      ).length;
    });
    setTempFilterSelectedValue(updatedTempFilter);
    setGroupFilterSelectedValue(updatedGroupFilter);
    setTaxFilterSelectedValue(updatedTaxFilter);
    setAllergenFilterSelectedValue(updatedAllergenFilter);
    setFilterSelectedValue([...updatedTempFilter, ...updatedGroupFilter, ...updatedTaxFilter, ...updatedAllergenFilter]);
    setProducts(filtered);
    setFilteredProducts(filtered);
    setFilterCounts(updatedFilterCounts);
  };

  const clearFilterSearch = () => {
    setProducts(tempproducts);
    setFilterSelectedValue([]);
    setSelectedStatus(' ');
    setTempFilterSelectedValue([]);
    setAllergenFilterSelectedValue([]);
    setGroupFilterSelectedValue([]);
    setTaxFilterSelectedValue([]);
    setFilterapply(false);
    setMoreFilter(false);
  };
  // Helper used by handlefilterChange to apply filter with fresh status value
  const applyFilterWith = ({
    tempFilterSelectedValue: tFSV,
    allergenFilterSelectedValue: aFSV,
    groupFilterSelectedValue: gFSV,
    taxFilterSelectedValue: txFSV,
    selectedStatus: selStatus,
  }) => {
    let filtered = tempproducts;
    filtered = tempproducts.filter(product =>
      tFSV.length === 0 || tFSV.includes(product.SuitableFor.toLowerCase())
    );
    if (aFSV.length > 0) {
      const expandedAllergens = aFSV.flatMap(f => f.toLowerCase().split(/\s+/));
      filtered = filtered.filter(product => {
        const usp = (product.productUSP || "").toLowerCase();
        const uspWords = usp.replace(/[^a-z\s]/g, ' ').split(/\s+/);
        const containsAllergen = expandedAllergens.some(allergen =>
          uspWords.some(word => {
            const cleanWord = word.replace(/[^a-z]/g, '');
            return cleanWord === allergen || cleanWord.replace(/s$/, '') === allergen.replace(/s$/, '');
          })
        );
        return usp.includes("no allergens") || !containsAllergen || usp.trim() === "";
      });
    }
    filtered = filtered.filter(product =>
      gFSV.length === 0 || gFSV.includes(product.ProductGroup.toLowerCase())
    );
    filtered = filtered.filter(product =>
      txFSV.length === 0 || txFSV.includes(product.productTaxCode.toLowerCase())
    );
    if (selStatus != ' ') {
      filtered = filtered.filter(product =>
        product.PDP_Status.toLowerCase() === selStatus.toLowerCase().trim()
      );
    }
    const updatedFilterCounts = {};
    tFSV.forEach((filter) => {
      updatedFilterCounts[filter] = filtered.filter(
        (item) => item.SuitableFor && item.SuitableFor.toLowerCase().trim() === filter.toLowerCase().trim()
      ).length;
    });
    aFSV.forEach(filter => {
      const expanded = filter.toLowerCase().split(/\s+/);
      updatedFilterCounts[filter] = filtered.filter(product => {
        const usp = (product.productUSP || "").toLowerCase();
        const uspWords = usp.replace(/[^a-z\s]/g, ' ').split(/\s+/);
        const containsAllergen = expanded.some(allergen =>
          uspWords.some(word => {
            const cleanWord = word.replace(/[^a-z]/g, '');
            return cleanWord === allergen || cleanWord.replace(/s$/, '') === allergen.replace(/s$/, '');
          })
        );
        return usp.includes("no allergens") || !containsAllergen || usp.trim() === "";
      }).length;
    });
    gFSV.forEach((filter) => {
      updatedFilterCounts[filter] = filtered.filter(
        (item) => item.ProductGroup && item.ProductGroup.toLowerCase().trim() === filter.toLowerCase().trim()
      ).length;
    });
    txFSV.forEach((filter) => {
      updatedFilterCounts[filter] = filtered.filter(
        (item) => item.productTaxCode && item.productTaxCode.toLowerCase().trim() === filter.toLowerCase().trim()
      ).length;
    });
    setProducts(filtered);
    setFilterSelectedValue([...aFSV, ...tFSV, ...gFSV, ...txFSV]);
    setFilterCounts(updatedFilterCounts);
    setFilterapply(true);
    setFilteredProducts(filtered);
    setPreviousFilteredProducts(filtered);
    setMoreFilter(false);
  };

  const applyFilter = () => {
    applyFilterWith({
      tempFilterSelectedValue,
      allergenFilterSelectedValue,
      groupFilterSelectedValue,
      taxFilterSelectedValue,
      selectedStatus,
    });
  };

  const showConfirmationDialog = () => {
    if (reason !== "") {
      setShowReasonPopup(false);
      setShowDialog(true);
    } else {
      setReasonError(true);
    }
  };

  const showReasonDialogFn = (productNumber, action) => {
    setShowReasonPopup(true);
    setReasonError(false);
    setConfirmationAction({ productNumber, action });
  };

  const hideConfirmationDialog = () => {
    setShowDialog(false);
    setShowReasonPopup(false);
    setReasonError(false);
    setReason("");
  };

  const handleContextMenu = (event) => {
    event.preventDefault();
  };

  const ProductStatuslog = (productNumber, product_description) => {
    let URL = BaseUrl + "admin/productlog/" + productNumber;
    http
      .get(URL)
      .then(async (response) => {
        let responseData = response.data.data;
        viewlogDetails(responseData, product_description, productNumber);
      })
      .catch((error) => {
        console.error("Error updating customer status:", error);
      });
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    const hours = date.getUTCHours().toString().padStart(2, "0");
    const minutes = date.getUTCMinutes().toString().padStart(2, "0");
    const seconds = date.getUTCSeconds().toString().padStart(2, "0");
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  };

  const viewlogDetails = (prd_det, product_description, productNumber) => {
    let popupResult = (
      <Popup
        extClass="info-poup show"
        closebtn={
          <>
            <span
              onClick={() => setPopuplogView("")}
              className="close"
            ></span>
          </>
        }
        headMoreTxt={
          <>
            <div className="order-top">
              <h4>
                <span>
                  {product_description} - {productNumber}
                </span>
              </h4>
            </div>
          </>
        }
        bodyMoreTxt={
          <>
            <div className="bottom vendor-details prd-log">
              {prd_det && prd_det.length > 0 ? (
                prd_det.map((prd_item) => {
                  const [prdstatus, notes] = prd_item.noteText.split(/-(.+)/);
                  let prdactionstatus =
                    prdstatus.trim() === "activate" ? t("activated_txt") : t("deactivated_txt");
                  let createdby = prd_item.createdBy ? (
                    <>
                      <span className="log-user">{prd_item.createdBy}</span>
                      <span className="log-line">|</span>
                    </>
                  ) : (
                    ""
                  );
                  return (
                    <div className="info-item">
                      <div className="info-innr">
                        <div className="flex-log-hdr">
                          <p>
                            <span className="labeltxt acn-by">{prdactionstatus}</span>
                          </p>
                          <div className="hdrlog-rit">
                            {createdby}
                            <span className="log-date">
                              {dateformatwithuktime(prd_item.createdAt)}
                            </span>{" "}
                          </div>
                        </div>
                        <p>
                          <span className="labeltxt log-reason">{t("reason_txt")}: </span>
                          {notes ? notes.trim() : ""}
                        </p>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="no-logs">{t("no_logs_txt")}</div>
              )}
            </div>
          </>
        }
      />
    );
    setPopuplogView(popupResult);
  };

  const toggleProductStatus = (productNumber) => {
    const product = products.find((p) => p.productNumber === productNumber);
    const isCurrentlyActive = product.PDP_Status;
    const action = isCurrentlyActive === "activate" ? t("deactivate_txt") : t("activatee_txt");
    showReasonDialogFn(productNumber, action);
  };

  const confirmActionHandler = () => {
    const { productNumber, action } = confirmationAction;
    confirmAction(productNumber, action);
    hideConfirmationDialog();
  };

  const confirmAction = (productNumber, action) => {
    var loginDetails = {};
    if (sessionStorage.getItem("authData")) {
      loginDetails = JSON.parse(sessionStorage.getItem("authData"));
    }
    let URL = BaseUrl + "product/status";
    const payload = {
      PDP_ProductNumber: productNumber,
      action: action,
    };
    http
      .put(URL, payload)
      .then(async (response) => {
        if (response.status === 200) {
          setProducts(prev =>
            prev.map(product =>
              product.productNumber === productNumber
                ? { ...product, PDP_Status: payload.action }
                : product
            )
          );
          setTempproducts(prev =>
            prev.map(product =>
              product.productNumber === productNumber
                ? { ...product, PDP_Status: payload.action }
                : product
            )
          );
          let noteURL = BaseUrl + "admin/productlog";
          const notepayload = {
            productNumber: productNumber,
            noteText: action + " - " + reason,
            createdBy: loginDetails.adminName,
          };
          http.post(noteURL, notepayload).then(async (response) => {
            const actionMsg = action.trim() === "activate" ? t("activated_text") : t("deactivated_text");
            setShowPopup(true);
            setUploadMessage(t("product_action_success", { action: actionMsg }));
          });
          hideConfirmationDialog();
        }
      })
      .catch((error) => {
        console.error("Error updating product status:", error);
        alert(t("failed_to_update_product_status_txt"));
      });
  };

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handlePriceButtonClick = () => {
    fileInputPrdpriceRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      setUploadMessage("");
      setShowPopup(false);
    }
  };

  const handlePrdpriceFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setPrdpriceselectedFile(file);
      setUploadMessage("");
      setShowPopup(false);
    }
  };

  const handleUpload = (file) => {
    if (file) {
      const reader = new FileReader();
      setIsUploading(true);
      reader.onload = (event) => {
        const wb = read(event.target.result);
        const sheets = wb.SheetNames;
        if (sheets.length) {
          let rows = utils.sheet_to_json(wb.Sheets[sheets[0]]);
          let URL = BaseUrl + "admin/product/import";
          const payload = { data: rows };
          http
            .post(URL, payload)
            .then((response) => {
              getProducts(priceCode);
              setIsUploading(false);
              setUploadMessage(t("pdt_import_success_txt"));
              setShowPopup(true);
            })
            .catch((error) => {
              console.log(error);
            });
        }
      };
      reader.readAsArrayBuffer(file);
    }
  };

  const handlePrdpriceUpload = (file) => {
    if (file) {
      const reader = new FileReader();
      setIsUploading(true);
      reader.onload = (event) => {
        const wb = read(event.target.result);
        const sheets = wb.SheetNames;
        if (sheets.length) {
          let rows = utils.sheet_to_json(wb.Sheets[sheets[0]]);
          let URL = BaseUrl + "admin/product/importprice";
          const payload = { data: rows };
          http
            .post(URL, payload)
            .then((response) => {
              getProducts(priceCode);
              setIsUploading(false);
              setUploadMessage(t("priceband_import_sucess_txt"));
              setShowPopup(true);
            })
            .catch((error) => {
              console.log(error);
            });
        }
      };
      reader.readAsArrayBuffer(file);
    }
  };

  const closePopup = () => {
    setShowPopup(false);
    setUploadMessage("");
  };

  const importButtonClick = (value) => {
    setPopupImportView(true);
    setImportValue(value);
  };

  const importClosepopup = (event, shouldUpload, file, importValue) => {
    if (shouldUpload && file) {
      uploadFile(file, importValue);
    }
    setPopupImportView(false);
    setImportValue("");
    setSelectedFile(null);
  };

  const uploadFile = (file, importVal) => {
    if (importVal === "Product") {
      handleUpload(file);
    } else if (importVal === "Price Band") {
      handlePrdpriceUpload(file);
    }
  };
  // Render
  if (sessionStorage.getItem("authData")) {
    var loginemail = JSON.parse(sessionStorage.getItem("authData")).adminEmail;
  }

  const hasDepot = (dep) => Boolean(dep && String(dep).trim() !== "");
  let displayedProducts = products;
  if (fullText && Array.isArray(products) && products.length) {
    displayedProducts = products
      .map((p, idx) => ({ p, idx }))
      .sort((a, b) => {
        const aHas = hasDepot(a.p.activeDepots);
        const bHas = hasDepot(b.p.activeDepots);
        if (aHas === bHas) return a.idx - b.idx;
        return aHas ? -1 : 1;
      })
      .map(({ p }) => p);
  }

  const columns = [
    {
      name: t("product_img_txt"),
      selector: (row) => (
        <div onClick={() => handleImage(row)}>
          {" "}
          <img
            width="64"
            src={
              row.productImage !== "" && row.productImage !== null
                ? row.productImage
                : NoImage
            }
            onContextMenu={handleContextMenu}
            style={{ cursor: "not-allowed" }}
          />{" "}
        </div>
      ),
      sortable: false,
    },
    {
      name: t("product_name_txt"),
      selector: (row) => row.productDescription,
      sortable: false,
    },
    {
      name: t("product_code_txt"),
      selector: (row) => row.productNumber,
      sortable: false,
    },
    {
      name: t("unit_of_sale_txt"),
      selector: (row) => row.packageSize,
      sortable: false,
    },
    // {
    //   name: t("category_txt"),
    //   selector: (row) =>
    //     row.categoryId === "1"
    //       ? t("categories.pizza")
    //       : row.categoryId === "10" || row.categoryId === "13" || row.categoryId === "11" || row.categoryId === "12"
    //         ? t("categories.pasta_rice_noodle_sauces")
    //         : row.categoryId === "14"
    //           ? t("categories.desserts")
    //           : "",
    //   sortable: true,
    // },
    {
      name: t("category_txt"),
      selector: (row) =>
        row.categoryId === "1"
          ? `${t("categories.pizza")}`
          : row.categoryId === "10" ||
            row.categoryId === "13" ||
            row.categoryId === "11" ||
            row.categoryId === "12"
          ? `${t("categories.pasta_rice_noodle_sauces")}`
          : row.categoryId === "14"
          ? `${t("categories.desserts")}`
          : "",
      sortable: true,
    },
    {
      name: t("actions_txt"),
      selector: (row, index) => (
        <div style={{ display: "flex" }} className="action-btns">
          {canAction('manage_products', 'view') && (
            <a
              className="button title-tooltip title-up"
              data-title={t("view_details_txt")}
              style={{ color: "white" }}
              onClick={() => viewProductDetails(row)}
            >
              <i className="fa fa-eye" aria-hidden="true"></i>
            </a>
          )}
          {canAction('manage_products', 'edit') && (
            (loginemail === 'karthik@k2bsolutions.in' || loginemail === 'k2bsolutions@gmail.com') && (<a
              className="button title-tooltip title-up"
              data-title={t("edit_product_details_txt")}
              style={{ color: "white" }}
              onClick={() => editProduct(row)}
            >
              <i className="fa fa-edit" aria-hidden="true"></i>
            </a>))}
           
          {canAction('manage_products', 'view') && (
            <a
              className="button title-tooltip title-up"
              data-title={t("view_price_band_details_txt")}
              style={{ color: "white" }}
              onClick={() => viewPricebandDetails(row)}
            >
              <i className="fa fa-gbp" aria-hidden="true"></i>
            </a>
          )}
          {canAction('manage_products', 'activate') && (
            <a
              className="title-tooltip title-up"
              data-title={t("product_act_deact_txt")}
            >
              <button
                onClick={() => toggleProductStatus(row.productNumber)}
                className={`button ${row.PDP_Status === "activate" ? t("activatee_txt") : t("deactivate_txt")}`}
              >
                <i
                  className={`fa ${row.PDP_Status === "activate" ? "fa-unlock" : "fa-lock"}`}
                  aria-hidden="true"
                ></i>
              </button>
            </a>
          )}
          {canAction('manage_products', 'activate') && (
            <a
              className="button title-tooltip title-up"
              data-title={t("product_status_log")}
              onClick={() => ProductStatuslog(row.productNumber, row.productDescription)}
            >
              <i className="fa fa-history"></i>
            </a>
          )}
          {canAction('manage_products', 'depot') && fullText && row?.activeDepots ? (
            <a
              className="button title-tooltip title-up"
              data-title={t("enabled_by_deot_txt")}
              style={{ color: "white" }}
              onClick={() => viewDepotDetails(row)}
            >
              <i className="fa fa-map-marker" aria-hidden="true"></i>
            </a>
          ) : ''}
        </div>
      ),
      sortable: false,
    },
  ];

  const customStyles = {
    rows: { style: { minHeight: "25px" } },
    headCells: { style: { padding: "8px" } },
    cells: { style: { padding: "8px" } },
  };

  const paginationComponentOptions = {
    rowsPerPageText: "",
    rangeSeparatorText: "",
    selectAllRowsItem: true,
    selectAllRowsItemText: "",
    noRowsPerPage: "",
  };

  return (
    <>
      {alertPopup == true && (
        <CommonAlert title={t("alert_txt")} message={alertMessage} />
      )}
      <section className="dashboard-block">
        <Sidebar />
        <div className="dash-left">
          <Header />
          <section className="cart-block">
            <div className="container">
              <div className="flex-title">
                <h1 className="checkout-title">{t("products_txt")}</h1>
                <div className="prod-import-btn odr-expo-btn">
                  {canAction('manage_products', 'export') && (
                    <a
                      data-title={t("export_active_priceband_txt")}
                      type="button"
                      className="export-btn button title-tooltip title-left"
                      onClick={handleExportClick}
                    >
                      {t("export_active_priceband_txt")}
                    </a>
                  )}
                  {(loginemail === 'karthik@k2bsolutions.in' || loginemail === 'k2bsolutions@gmail.com') && (
                  <>
                    {canAction('manage_products', 'productimport') && (
                      <a
                        data-title={t("import_product_records_txt")}
                        className="import-btn button title-tooltip title-left"
                        onClick={() => importButtonClick("Product")}
                      >
                        {t("product_import_txt")}
                      </a>
                    )}{" "}
                    {canAction('manage_products', 'pricebandimport') && (
                      <a
                        data-title={t("import_price_bands_records_txt")}
                        className="import-btn button title-tooltip title-left"
                        onClick={() => importButtonClick("Price Band")}
                      >
                        {t("priceband_import_txt")}
                      </a>
                    )}
                  </>
                  )}
                </div>
              </div>
              <div className="checkout-table">
                <div className="table-filter search-orders">
                  <div className="table-search-reset">
                    <div className="products-search-left">
                      <div className="table-search">
                        <input
                          type="text"
                          value={searchTextVal}
                          onChange={(e) => handleChange(e.target.value)}
                          className="form-control"
                          placeholder={t("searchby_pdtcode_pdtname_txt")}
                        />
                      </div>
                      <button
                        className="submitbtn button search-prd-btn"
                        onClick={() => filterData('search', searchTextVal)}
                      >
                        <i className="fa fa-search"></i>
                      </button>
                      <button
                        className="resetbtn"
                        type="reset"
                        onClick={handleReset}
                      >
                        {t("reset_txt")}
                      </button>
                    </div>
                  </div>
                  {!loading && tempproducts?.length > 0 &&
                    <div
                      className={
                        filterValueList.length > 0
                          ? "select-drop"
                          : "select-drop no-filter-list"
                      }
                      ref={dropdownRef}
                    >
                      <div className="orders-dropdown prod-select-drop">
                        <select
                          className="handle-srch"
                          value={selectedStatus}
                          onChange={(e) => handlefilterChange(e.target.value)}
                        >
                          <option value="" disabled>{t("status_txt")}</option>
                          <option value=" ">{t("all_txt")}</option>
                          <option value="activate">{t("active_txt")}</option>
                          <option value="deactivate">{t("inactive_txt")}</option>
                        </select>
                      </div>
                      <a
                        className={
                          isElementVisible == true
                            ? "filter-btn button active"
                            : "filter-btn button"
                        }
                        onClick={openFilterOption}
                      >
                        {t("more_filters_txt")}{" "}
                        <span className="filter-icon">
                          <i className="fa fa-sliders" aria-hidden="true"></i>
                        </span>
                      </a>
                    </div>}
                </div>
                {filterSelectedValue.length > 0 && filterapply && (
                  <div className="filter-field-wrap">
                    <h3>{t("filteredby_txt")}</h3>
                    <div className="filter-show-bx">
                      {filterSelectedValue.map((item) => {
                        const isAllergen = allergenFilterSelectedValue?.includes(item.toLowerCase());
                        const displayText =
                          item === "non vegetarian"
                            ? t("meat_txt")
                            : isAllergen
                              ? `${capitalizeFirstLetter(item)}`
                              : capitalizeFirstLetter(item);
                        return (
                          <span
                            className="filters"
                            key={item}
                            onClick={(e) => removeFilter(e, item)}
                          >
                            <a className="filter-x"></a>
                            {displayText}:
                            <span className="filter-count">
                              {filterCounts[item]}
                            </span>
                          </span>
                        );
                      })}
                      <span
                        className="filters clr-all"
                        onClick={clearFilterSearch}
                      >
                        {t("clearall_txt")}
                      </span>
                    </div>
                  </div>
                )}
                <div className="table_overflow products-table">
                  {canAction('manage_products', 'depot') && (
                    <div className="full-text-toggle custom_check-box">
                      <div className="check-box">
                        <input
                          type="checkbox"
                          id="fullTextToggle"
                          checked={fullText}
                          onChange={() => setFullText(prev => !prev)}
                        />
                        <label htmlFor="fullTextToggle">
                          {t("depot_based_product_restriction_txt")}
                        </label>
                      </div>
                    </div>
                  )}
                  <DataTable
                    columns={columns}
                    data={displayedProducts}
                    customStyles={customStyles}
                    noDataComponent={
                      <div className="no-records-found">
                        {t("no_search_product_txt")}
                      </div>
                    }
                    pagination
                    paginationPerPage={25}
                    progressPending={loading}
                    paginationRowsPerPageOptions={[25, 50, 75, 100]}
                    paginationComponentOptions={paginationComponentOptions}
                  />
                </div>
              </div>
            </div>
          </section>
          <Footer />
        </div>
        {showReasonPopup && (
          <div className="custom-alert-pop paylater-popup">
            <div className="custom-alert-container">
              <div className="custom-alert-wrap">
                <div className="custom-alert-header">
                  <h4>{confirmationAction.action}</h4>
                </div>
                <div className="custom-alert-body">
                  <div className="input-field">
                    <span className="labeltxt">{t("post_comment_label_txt")}</span>
                    <textarea
                      name="reason"
                      onChange={handleReasonChange}
                    ></textarea>
                    {reasonError && (
                      <div className="err-msg">{t("reason_error_txt")}</div>
                    )}
                  </div>
                  <div className="alert-buttons">
                    <button
                      title={t("submit_txt")}
                      onClick={showConfirmationDialog}
                      className="popup-alert-btn button"
                    >
                      {t("submit_txt")}
                    </button>
                    <button
                      title={t("cancel_txt")}
                      onClick={hideConfirmationDialog}
                      className="popup-alert-btn button"
                    >
                      {t("cancel_txt")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {showExportAlert && (
          <div className="product-import-pop">
            <div className="product-import-pop-overlay"></div>
            <div className="product-import-wrap">
              <span className="close-import-pop" onClick={handleCloseExportAlert}></span>
              <div className="product-import-body">
                <div className="product-import-header">
                  <h3>{t("select_price_bands_txt")}</h3>
                </div>
                <div className="product-import-content">
                  <div className="product-export-inner">
                    <div className="custom_check-box">
                      <div className="check-box">
                        <input
                          type="checkbox"
                          id="selectAllPriceBands"
                          checked={selectedPriceBands.length === priceBands.length}
                          onChange={handleSelectAllPriceBands}
                        />
                        <label htmlFor="selectAllPriceBands">{t("select_all_txt")}</label>
                      </div>
                    </div>
                    <div className="note-text">
                      <span>{t("selected_txt")}: {selectedPriceBands.length} / {priceBands.length}</span>
                    </div>
                    <div className="product-export-band">
                      {priceBands.map(band => (
                        <div key={band} className="custom_check-box">
                          <div className="check-box">
                            <input
                              type="checkbox"
                              id={band}
                              checked={selectedPriceBands.includes(band)}
                              onChange={() => handlePriceBandSelection(band)}
                            />
                            <label htmlFor={band}>{band}</label>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="product-export-type">
                      <h5>{t("export_type_txt")}:</h5>
                      <div className="custom_check-box">
                        <div className="radio-box">
                          <input
                            type="radio"
                            id="grouped"
                            name="exportType"
                            value="grouped"
                            checked={exportType === 'grouped'}
                            onChange={handleExportTypeChange}
                            disabled={selectedPriceBands.length === 0}
                          />
                          <label htmlFor="grouped">{t("group_based_price_band_txt")}</label>
                        </div>
                      </div>
                      <div className="custom_check-box">
                        <div className="radio-box">
                          <input
                            type="radio"
                            id="column"
                            name="exportType"
                            value="column"
                            checked={exportType === 'column'}
                            onChange={handleExportTypeChange}
                            disabled={selectedPriceBands.length === 0}
                          />
                          <label htmlFor="column">{t("column_wise_price_band_txt")}</label>
                        </div>
                      </div>
                    </div>
                    <div className="product-confirm-message">
                      <div className="custom_check-box">
                        <div className="check-box">
                          <input
                            type="checkbox"
                            id="confirmExport"
                            checked={confirmExport}
                            disabled={selectedPriceBands.length === 0}
                            onChange={(e) => setConfirmExport(e.target.checked)}
                          />
                          <label
                            htmlFor="confirmExport"
                            style={{
                              cursor: selectedPriceBands.length === 0 ? 'not-allowed' : 'pointer',
                              color: selectedPriceBands.length === 0 ? '#aaa' : 'inherit'
                            }}
                          >
                            {t("confirm_export_active_priceband_txt")}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="product-import-bottom">
                  <button className="button cancel-btn" onClick={handleCloseExportAlert}>{t("cancel_txt")}</button>
                  <button
                    onClick={
                      selectedPriceBands.length > 0 && confirmExport
                        ? handleExportToExcel
                        : null
                    }
                    className={`button upload-btn ${selectedPriceBands.length === 0 || !confirmExport ? 'disabled-btn' : 'active'}`}
                  >{t("ok_txt")}</button>
                </div>
              </div>
            </div>
          </div>
        )}
        {showDialog && (
          <div className="custom-alert-pop paylater-popup">
            <div className="custom-alert-container">
              <div className="custom-alert-wrap">
                <div className="custom-alert-header">
                  <h4>{t("alert_txt")}</h4>
                </div>
                <div className="custom-alert-body">
                  <p>
                    {t("product_confirmation", {
                      action: confirmationAction.action,
                    })}
                  </p>
                  <div className="alert-buttons">
                    <button
                      onClick={confirmActionHandler}
                      className="popup-alert-btn button"
                    >
                      {t("ok_txt")}
                    </button>
                    <button
                      onClick={hideConfirmationDialog}
                      className="popup-alert-btn button"
                    >
                      {t("cancel_txt")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {showPopup && (
          <div className="custom-alert-pop paylater-popup">
            <div className="custom-alert-container">
              <div className="custom-alert-wrap">
                <div className="custom-alert-header">
                  <h4>{t("alert_txt")}</h4>
                </div>
                <div className="custom-alert-body">
                  <p>{uploadMessage}</p>
                  <div className="alert-buttons">
                    <button
                      onClick={closePopup}
                      className="popup-alert-btn button"
                    >
                      {t("ok_txt")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {popupView}
        {depotPopupView}
        {popuplogView}
        {editProdDet && (
          <EditProductDetails
            editProddet={ProductDet}
            editloading={loading}
            popupclose={editclosepopup}
            editProdDetails={editPrdDetails}
          />
        )}
        {pricebandView}
        {viewImage}
        {popupImportView && (
          <Importpopup
            closePopup={importClosepopup}
            impValue={importValue}
          />
        )}
        {isUploading && (
          <div className="loading-overlay">
            <div className="loading-message">{t("importing_load_txt")}</div>
          </div>
        )}
        {moreFilter && (
          <div class="product-import-pop more-filter-pop">
            <div class="product-import-pop-overlay"></div>
            <div class="product-import-wrap">
              <span class="close-import-pop" onClick={closeFilterOption}></span>
              <div class="product-import-body">
                <div class="product-import-header">
                  <h3>{t("more_filters_txt")}</h3>
                </div>
                <div class="product-import-content">
                  <div class="filter-accordion-grp">
                    <h5>{t("suitable_for_txt")}</h5>
                    <div className="filter-options">
                      {filterValueList.length == 0 && (
                        <div className="no-filter">
                          <p>{t("no_filter_for_category_txt")}</p>
                        </div>
                      )}
                      {filterValueList.length > 0 &&
                        filterValueList.map((item, index) => {
                          return (
                            <a
                              className={
                                !tempFilterSelectedValue.includes(item.toLowerCase())
                                  ? "filter-val"
                                  : "filter-val active"
                              }
                              onClick={() => filterData('suitablefor', item)}
                              key={index}
                            >
                              {item === 'Non Vegetarian' ? t("meat_txt") : item}{" "}
                              <span
                                className="remove-filter"
                                onClick={(e) => removeFilterpop(e, item)}
                              ></span>
                            </a>
                          );
                        })}
                    </div>
                  </div>
                  <div class="filter-accordion-grp">
                    <h5>{t("product_group_txt")}</h5>
                    <div class="filter-options">
                      {groupFilterList?.length > 0 &&
                        groupFilterList.map((item, index) => {
                          return (
                            <a
                              className={
                                !groupFilterSelectedValue.includes(item.toLowerCase())
                                  ? "filter-val"
                                  : "filter-val active"
                              }
                              onClick={() => filterData('groupfilter', item)}
                              key={index}
                            >
                              {item}{" "}
                              <span
                                className="remove-filter"
                                onClick={(e) => removeFilterpop(e, item)}
                              ></span>
                            </a>
                          );
                        })}
                    </div>
                  </div>
                  <div class="filter-accordion-grp">
                    <h5>{t("tax_code_txt")}</h5>
                    <div class="filter-options">
                      {taxFilterList.length > 0 &&
                        taxFilterList.map((item, index) => {
                          return (
                            <a
                              className={
                                !taxFilterSelectedValue.includes(item.toLowerCase())
                                  ? "filter-val"
                                  : "filter-val active"
                              }
                              onClick={() => filterData('taxfilter', item)}
                              key={index}
                            >
                              {item}{" "}
                              <span
                                className="remove-filter"
                                onClick={(e) => removeFilterpop(e, item)}
                              ></span>
                            </a>
                          );
                        })}
                    </div>
                  </div>
                  <div className="filter-accordion-grp">
                    <h5>{t("allergens_txt")}</h5>
                    <div className="filter-options">
                      {allergens?.length === 0 && (
                        <div className="no-filter">
                          <p>{t("no_allergen_filter_txt")}</p>
                        </div>
                      )}
                      {allergens?.length > 0 &&
                        allergens.map((Label, index) => {
                          return (
                            <a
                              className={
                                !allergenFilterSelectedValue?.includes(Label.toLowerCase())
                                  ? "filter-val"
                                  : "filter-val active"
                              }
                              onClick={() => filterData("allergenfilter", Label)}
                              key={index}
                            >
                              {Label}
                              <span
                                className="remove-filter"
                                onClick={(e) => removeFilterpop(e, Label)}
                              ></span>
                            </a>
                          );
                        })}
                    </div>
                  </div>
                </div>
                <div class="product-import-bottom">
                  <div class="filter-btns">
                    <button type="button" class="button clear-btn" value="Clear Filters" title={t("clear_txt")} onClick={clearFilterSearch}>{t("clear_txt")}</button>
                    <button type="button" class="button apply-btn" value="Apply Filters" title={t("apply_txt")} onClick={applyFilter}>{t("apply_txt")}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </section>
      <div className="common"></div>
    </>
  );
};

export default Products;
